import React, { useState, useEffect, useRef } from 'react';
import MainHero from "./Components/MainHero";
import MainUsers from "./Components/Users/MainUsers.js"
import Testimonials from "./Components/Testimonials";
import CHIC from "./Components/CHIC";
import Legal from "./Components/Legal";

const Homepage = () => {
    return (
        <div className="w-full flex flex-col">
            <MainHero />
            <MainUsers />
            <Testimonials />
            <CHIC />
            <div className="w-full flex bg-charmPurple ">
                <Legal />
            </div>
        </div>
    );
}

export default Homepage;